import { InfoIcon } from "@phosphor-icons/react";

import Icon, { IconVariant, type IconProps } from "./Icon";

const HelpIcon = ({
  size = 12,
  variant = IconVariant.TERTIARY,
  ...props
}: Omit<IconProps, "component">) => {
  return <Icon component={InfoIcon} variant={variant} size={size} {...props} />;
};

export default HelpIcon;
